<div class="p-a-xl">
    <cipo-complex-conditions [workflowId]="33" [transitionId]="55"></cipo-complex-conditions>
</div>

<div class="p-a-xl">
    <cipo-complex-conditions [screenId]="11" [entityId]="45"></cipo-complex-conditions>
</div>
